import { client } from "../client";
import type {
	EmailValidationCheckResponse,
	EmailValidationSendResponse,
	InvitationLinkResponse,
	InvitationResponse,
	LoginResponse,
	LogoutResponse,
	NewPasswordResponse,
	ResetPasswordResponse,
} from "../types/axios.types";
import type { Center } from "../types/center.types";
import type { User } from "../types/user.types";
import type { Address } from "../types/address.types";

// Request an authentication token with credentials
export const login = async ({
	email,
	password,
}: {
	email: string;
	password: string;
}) => {
	const response = await client.post<LoginResponse>("/auth/login", {
		email,
		password,
	});
	return response.data;
};

export const invitation = async ({
	token,
	firstName,
	lastName,
	role,
	password,
	phoneNumber,
}: {
	token: string;
	firstName: string;
	lastName: string;
	role: string;
	password: string;
	phoneNumber: string;
}) => {
	const response = await client.post<InvitationResponse>("/auth/invitation", {
		token,
		firstName,
		lastName,
		role,
		password,
		phoneNumber,
	});
	return response.data;
};

export const invitationLink = async ({
	token,
	email,
	password,
}: {
	token: string;
	email: string;
	password: string;
}) => {
	const response = await client.post<InvitationLinkResponse>(
		"/auth/invitation/link",
		{
			token,
			password,
			email,
		},
	);
	return response.data;
};

export const logout = async () => {
	const response = await client.post<LogoutResponse>("/auth/logout");
	return response.data;
};

export const resetPassword = async ({ email }: { email: string }) => {
	const response = await client.post<ResetPasswordResponse>(
		"/auth/password/reset",
		{
			email: email,
		},
	);
	return response.data;
};

export const newPassword = async ({
	password,
	token,
}: {
	password: string;
	token: string;
}) => {
	const response = await client.post<NewPasswordResponse>(
		"/auth/password/new",
		{
			password,
			token,
		},
	);
	return response.data;
};

export const emailValidationSend = async ({ email }: { email: string }) => {
	const response = await client.post<EmailValidationSendResponse>(
		"/auth/signup/validation/send",
		{
			email,
		},
	);
	return response.data;
};

export const emailValidationCheck = async ({
	email,
	code,
}: {
	email: string;
	code: string;
}) => {
	const response = await client.post<EmailValidationCheckResponse>(
		"/auth/signup/validation/check",
		{
			email,
			code,
		},
	);
	return response.data;
};

export const signUp = async ({
	user,
	code,
	center,
	billingAddress,
	shippingAddress,
}: {
	user?: Partial<User>;
	code?: string;
	center?: Partial<Center>;
	billingAddress?: Partial<Address>;
	shippingAddress?: Partial<Address>;
}) => {
	const response = await client.post<EmailValidationCheckResponse>(
		"/auth/signup/",
		{
			user,
			code,
			center,
			billingAddress,
			shippingAddress,
		},
	);
	return response.data;
};
